// Declaración de tipos para Facebook Pixel
declare global {
  interface Window {
    fbq: (
      action: string,
      eventName: string,
      params?: Record<string, any>,
    ) => void
    _fbq: any
  }
}

// Inicializar Meta Pixel
export const initMetaPixel = () => {
  if (typeof window === 'undefined') return

  // Evitar inicializar múltiples veces
  if (window.fbq) return // Código del Meta Pixel
  ;(function (f: any, b: any, e: string, v: string, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]

    // Verificar que existe un elemento script antes de insertar
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      // Si no hay scripts, agregar al head
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
    null,
    null,
    null,
  )

  window.fbq('init', '1228743476050707')
  window.fbq('track', 'PageView')
}

// Track AddToCart event
export const trackAddToCart = (params?: {
  value?: number
  currency?: string
  content_name?: string
}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(
      'track',
      'AddToCart',
      params || {
        value: 6.39,
        currency: 'USD',
        content_name: 'The Nervous System Sleep Reset',
      },
    )
  }
}
